/**
 * MobilePhoneFrame — static phone chrome wrapper for the demo emulator.
 *
 * Renders a fixed-aspect-ratio phone body with a fake status bar at the top
 * and a static bottom nav bar (Alerts / Devices / Residents / Users / Settings).
 * Neither bar is interactive — they're visual decoration only so the demo
 * resembles the mobile app. The {children} render in between.
 */

const StatusBar = () => (
    <div className="mpf-status-bar">
        <span className="mpf-status-bar__time">3:46</span>
        <div className="mpf-status-bar__icons">
            {/* signal / wifi / battery — purely decorative */}
            <svg width="18" height="12" viewBox="0 0 18 12" aria-hidden="true">
                <rect x="0" y="8" width="2.5" height="4" rx="0.5" fill="currentColor" />
                <rect x="4" y="6" width="2.5" height="6" rx="0.5" fill="currentColor" />
                <rect x="8" y="3" width="2.5" height="9" rx="0.5" fill="currentColor" />
                <rect x="12" y="0" width="2.5" height="12" rx="0.5" fill="currentColor" />
            </svg>
            <svg width="22" height="22" viewBox="2 -2 12 10" aria-hidden="true">
                {/*<path d="M8 10.5l2.5-2.5a3.5 3.5 0 0 0-5 0L8 10.5z" fill="currentColor" />*/}
                <path d="M8 6.5l5-5a7 7 0 0 0-10 0l5 5z" fill="currentColor" opacity="0.6" />
            </svg>
            <svg width="26" height="12" viewBox="0 0 26 12" aria-hidden="true">
                <rect x="0.5" y="1" width="20" height="10" rx="2" fill="none" stroke="currentColor" strokeWidth="1" />
                <rect x="21" y="4" width="2" height="4" rx="0.5" fill="currentColor" />
                <rect x="2" y="2.5" width="15" height="7" rx="1" fill="currentColor" />
            </svg>
        </div>
    </div>
);

const NavItem = ({ icon, label, active = false }) => (
    <div className={`mpf-nav__item${active ? ' mpf-nav__item--active' : ''}`}>
        <div className="mpf-nav__icon">{icon}</div>
        <div className="mpf-nav__label">{label}</div>
    </div>
);

const BottomNav = () => (
    <div className="mpf-nav-bar">
        <NavItem
            active
            label="Alerts"
            icon={(
                <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
                    <path
                        d="M12 22a2 2 0 0 0 2-2h-4a2 2 0 0 0 2 2zm6-6V11a6 6 0 0 0-5-5.91V4a1 1 0 1 0-2 0v1.09A6 6 0 0 0 6 11v5l-2 2v1h16v-1z"
                        fill="currentColor"
                    />
                </svg>
            )}
        />
        {/*<NavItem*/}
        {/*    label="Devices"*/}
        {/*    icon={(*/}
        {/*        <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">*/}
        {/*            <rect x="4" y="3" width="16" height="18" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" />*/}
        {/*            <rect x="8" y="7" width="8" height="6" rx="1" fill="none" stroke="currentColor" strokeWidth="1.5" />*/}
        {/*            <circle cx="12" cy="17.5" r="1.2" fill="currentColor" />*/}
        {/*        </svg>*/}
        {/*    )}*/}
        {/*/>*/}
        {/*<NavItem*/}
        {/*    label="Residents"*/}
        {/*    icon={(*/}
        {/*        <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">*/}
        {/*            <circle cx="12" cy="8" r="4" fill="none" stroke="currentColor" strokeWidth="1.8" />*/}
        {/*            <path d="M4 21c0-4 4-7 8-7s8 3 8 7" fill="none" stroke="currentColor" strokeWidth="1.8" />*/}
        {/*        </svg>*/}
        {/*    )}*/}
        {/*/>*/}
        {/*<NavItem*/}
        {/*    label="Users"*/}
        {/*    icon={(*/}
        {/*        <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">*/}
        {/*            <circle cx="12" cy="8" r="4" fill="none" stroke="currentColor" strokeWidth="1.8" />*/}
        {/*            <path d="M4 21c0-4 4-7 8-7s8 3 8 7" fill="none" stroke="currentColor" strokeWidth="1.8" />*/}
        {/*        </svg>*/}
        {/*    )}*/}
        {/*/>*/}
        {/*<NavItem*/}
        {/*    label="Settings"*/}
        {/*    icon={(*/}
        {/*        <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">*/}
        {/*            <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="1.8" />*/}
        {/*            <path*/}
        {/*                d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h.01a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v.01a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"*/}
        {/*                fill="none"*/}
        {/*                stroke="currentColor"*/}
        {/*                strokeWidth="1.5"*/}
        {/*            />*/}
        {/*        </svg>*/}
        {/*    )}*/}
        {/*/>*/}
    </div>
);

const MobilePhoneFrame = ({ children }) => {
    return (
        <div className="mpf-wrap">
            <div className="mpf-device">
                <StatusBar />
                <div className="mpf-screen">{children}</div>
                <BottomNav />
            </div>
        </div>
    );
};

export default MobilePhoneFrame;
